import React, { useContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

import { DataContext } from '../../init/getData';

import { Modal, Col, Form, Row, DropdownButton, Dropdown, InputGroup } from 'react-bootstrap';
import { Space, Input, Tag, Button, Spin, Tabs, message, Card, theme } from 'antd';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcKindle, FcCancel, FcPlus } from "react-icons/fc";
import { FaCheck } from "react-icons/fa";
import { HiMinusCircle } from "react-icons/hi";

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Loader from '../../components/loader/loader';
import LoadPaymentJv from './functions/loadPaymentJv';
import SupplierForm from '../../purchaseTab/supplier/supplierForm';

import { numberFormatter, totalFormatter, decimalFormatter } from '../../components/formatters/numberFormatter';


import InvoiceInfo from './cards/receiptInfo';
import InvoiceAccount from './cards/receiptAccount';
import InvoiceJv from '../../components/journalVoucher/invoiceJv';
import InvoicePayments from './cards/invoicePayments';

const CashTransferForm = (props) => {

    const { api, userData, settingData, rateMainToSecondaryCurrency, auxAccountData, companyId, sessionId, defaultCurrency, rateToMainCurrency,
        productData, refData, branchData, projectData, yearId, currencyData } = useContext(DataContext);


    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role;
    const createdBy = parseInt(userData.id);

    const { showModal, toggleModal, table, title, refreshTable, size, isDebit, idRow, type } = props;
    const [loadingEffect, setLoadingEffect] = useState(false);
    const [validated, setValidated] = useState(false);
    const [isSpinning, setIsSpinning] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [journalVoucher, setJournalVoucher] = useState({});
    const [transactions, setTransactions] = useState([])

    const [showAddAccountModal, setShowAddAccountModal] = useState(false);

    const openAddAccountModal = (e) => {
        setShowAddAccountModal(!showAddAccountModal);
    }

    const refAddedAccount = async () => {
        try {
            setIsLoading(true);
            const dataArray = ['auxAccount']
            await refData(dataArray, companyId);
            setIsLoading(false);
        } catch (error) {
            console.error('Error refreshing data Contact Support');
        }
    };


    const today = new Date().toISOString().split('T')[0];
    const selectedCurrency = currencyData?.find(option => option.id === journalVoucher.currencyId);


    // idRow Change
    useEffect(() => {

        if (!isLoading) {

            setTransactions(idRow?.transactions || [])

            const getCurrency = currencyData?.find(option => option.id === settingData.piDefaultCurrencyId);
            const rate = parseFloat(getCurrency?.rate) || 0;

       
            setJournalVoucher(
                {
                    createdBy: createdBy,
                    sessionId: sessionId,
                    companyId: companyId,
                    yearId: yearId,
                    accountId: idRow?.accountId || null,
                    secondaryAccountId: idRow?.secondaryAccountId || null,
                    invoiceId: idRow?.invoiceId || null,
                    onInvoice: idRow?.onInvoice || false,
                    refNumber: idRow?.refNumber || '',
                    date: idRow?.date || today,
                    type: 'CashTransfer',
                    debit: idRow?.debit || 0,
                    credit: idRow?.credit || 0,
                    totalDebit: idRow?.totalDebit || 0,
                    totalCredit: idRow?.totalCredit || 0,
                    secondaryTotalDebit: idRow?.secondaryTotalDebit || 0,
                    secondaryTotalCredit: idRow?.secondaryTotalCredit || 0,
                    details: idRow?.details || '',
                    paymentType: 'cash',
                    downPayment: idRow?.downPayment || 0,
                    isDebit: idRow?.isDebit || isDebit,
                    discountType: idRow?.discountType || 'percentage',
                    discountPercentage: idRow?.discountPercentage || 0,
                    discountAmount: idRow?.discountAmount || 0,
                    currencyId: idRow?.currencyId || defaultCurrency?.id,
                    rate: idRow?.rate || defaultCurrency?.rate,

                    projectId: idRow?.projectId || userRole.projectId,
                    branchId: idRow?.branchId || userRole.branchId,
                }
            )
        }
    }, [isLoading, idRow, toggleModal]);


    // change totalDebit and totalCredit
    useEffect(() => {

        const total = journalVoucher.debit;

        const totalDebit = rateToMainCurrency(selectedCurrency, total);
        const totalCredit = rateToMainCurrency(selectedCurrency, total);

        setJournalVoucher((prev) => ({
            ...prev,
            debit: total,
            credit: total,
            totalDebit: totalDebit,
            totalCredit: totalCredit,
            secondaryTotalCredit: rateMainToSecondaryCurrency(totalDebit),
            secondaryTotalDebit: rateMainToSecondaryCurrency(totalCredit),
        }));

    }, [journalVoucher.debit]);


    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);
                const dataArray = ['auxAccount', 'currency', 'setting', 'journalVoucher', 'project', 'branch']
                await refData(dataArray, companyId);
                setIsLoading(false);
            } catch (error) {
                console.error('Error refreshing data Contact Support');
            }
        };
        if (showModal) {
            fetchData();
        }
    }, [showModal]);



    const handleSubmit = async (e) => {
        e.preventDefault();


        const form = document.getElementById('form');

        if (form.checkValidity() === false) {
            return;
        }


        setLoadingEffect(true);


        const data = {
            jvId: idRow?.id,
            transactions,
            journalVoucher,
        }

        const operation = idRow ? 'edit' : 'add'
        try {
            let res = await api.post(`journalVoucher/${operation}`, data);

            if (res.data.status) {
                toast.success(res.data.message);
                closeModal();
            } else {
                toast.error(res.data.message);
            }
        } catch (error) {
            toast.error("Failed Contact Support");
        } finally {
            setLoadingEffect(false);
            setValidated(false);
        }
    }

    const closeModal = () => {
        toggleModal();
        setValidated(false);
        const form = document.getElementById('form');
        form.reset();
        setTransactions([]);
        refreshTable();
    }



    return (
        <>
            {isLoading &&
                <Loader />
            }

            {!isLoading &&
                <Modal show={showModal} onHide={toggleModal} size={'xl'}>

                    <Modal.Header style={{ background: "#23576a" }} closeButton>
                        <Modal.Title style={{ color: "white" }}>{idRow ? 'Edit ' : 'Add '}{type}</Modal.Title>
                    </Modal.Header>

                    <Form validated={validated} id={'form'} onSubmit={handleSubmit} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); } }} >
                        <Modal.Body className="custom-scrollbar" style={{ backgroundColor: '#f0f2f5', maxHeight: '75vh', overflowY: 'auto' }}>


                            <Row className="mb-4">
                                <Col>
                                    <Card title="Account" bordered={false}>
                                        <InvoiceAccount
                                            journalVoucher={journalVoucher}
                                            setJournalVoucher={setJournalVoucher}
                                            validated={validated}
                                            openAddAccountModal={openAddAccountModal}
                                        />
                                    </Card>
                                </Col>
                            </Row>

                            <Row className="mb-4">
                                <Col>
                                    <Card title="Details" bordered={false}>
                                        <InvoiceInfo
                                            journalVoucher={journalVoucher}
                                            setJournalVoucher={setJournalVoucher}
                                            validated={validated}
                                        />
                                    </Card>
                                </Col>
                            </Row>

                    
                            <Row className="mb-4">
                                <Col>
                                    <Card title="Journal Voucher" bordered={false}>
                                        <InvoiceJv
                                            transactions={transactions}
                                        />
                                    </Card>
                                </Col>
                            </Row>
                        </Modal.Body>

                        <Modal.Footer>
                            <Button type="primary" loading={loadingEffect} htmlType="submit"
                                onClick={() => setValidated(true)}
                                style={{ marginLeft: '10px', backgroundColor: '#1d7790' }}>Save</Button>
                        </Modal.Footer>

                    </Form>

                    <LoadPaymentJv
                        setTransactions={setTransactions}
                        journalVoucher={journalVoucher}
                        selectedCurrency={selectedCurrency}
                    />


                </Modal >

            }

            <SupplierForm
                showModal={showAddAccountModal}
                toggleModal={openAddAccountModal}
                refAddedAccount={refAddedAccount}
            />
        </>
    )
}


export default CashTransferForm;